import { RootElement, PageElement } from "./src/layout";

export const wrapRootElement = RootElement;
export const wrapPageElement = PageElement;